import { render, staticRenderFns } from "./TableCollections.vue?vue&type=template&id=7e348ed7&"
import script from "./TableCollections.vue?vue&type=script&lang=js&"
export * from "./TableCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports